import { ISessionChangePinRequest } from '../models/AndromeTV.types';
import { Backend } from '../Backend';

export class PincodeApi {
  /**
   * Update pincode from old pin to new pin
   */
  static updatePinCode(backend: Backend, data: ISessionChangePinRequest): Promise<void> {
    const url = backend.makeUrl('v1/pincode');
    return backend.putJson(url, data, backend.bearer) as Promise<void>;
  }
}
